import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import Button from './Button';
import { ROUTES, CONTACT_INFO, BUSINESS_HOURS } from '../utils/constants';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          <div className="footer-section footer-brand">
            <Logo size="medium" />
            <p className="footer-tagline">
              Professional event staffing solutions designed to elevate your event experience with expert bartenders, waiters, and complete mobile bar services.
            </p>
            <div className="social-links">
              <a 
                href={CONTACT_INFO.instagram} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="social-link"
                aria-label="Follow us on Instagram"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" fill="currentColor"/>
                </svg>
                <span>Instagram</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to={ROUTES.HOME}>
                  <span className="link-icon">→</span>
                  Home
                </Link>
              </li>
              <li>
                <Link to={ROUTES.SERVICES}>
                  <span className="link-icon">→</span>
                  Services
                </Link>
              </li>
            <li>
              <Link to={ROUTES.ABOUT}>
                <span className="link-icon">→</span>
                About Us
              </Link>
            </li>
            <li>
              <Link to={ROUTES.GALLERY}>
                <span className="link-icon">→</span>
                Gallery
              </Link>
            </li>
            <li>
              <Link to={ROUTES.CONTACT}>
                <span className="link-icon">→</span>
                Contact
              </Link>
            </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Services</h3>
            <ul className="footer-links">
              <li>
                <Link to="/services#bartenders">
                  <span className="link-icon">→</span>
                  Professional Bartenders
                </Link>
              </li>
              <li>
                <Link to="/services#waiters">
                  <span className="link-icon">→</span>
                  Professional Waiters
                </Link>
              </li>
              <li>
                <Link to="/services#mixologists">
                  <span className="link-icon">→</span>
                  Cocktail Mixologists
                </Link>
              </li>
              <li>
                <Link to="/services#mobile-bar">
                  <span className="link-icon">→</span>
                  Mobile Bar Service
                </Link>
              </li>
              <li>
                <Link to="/services#brand-activation">
                  <span className="link-icon">→</span>
                  Brand Activation
                </Link>
              </li>
              <li>
                <Link to="/services#setup-breakdown">
                  <span className="link-icon">→</span>
                  Setup & Breakdown
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section footer-contact">
            <h3>Get In Touch</h3>
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <p className="contact-label">Email</p>
                  <a href={`mailto:${CONTACT_INFO.email}`} className="contact-value">
                    {CONTACT_INFO.email}
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <p className="contact-label">Phone</p>
                  <a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`} className="contact-value">
                    {CONTACT_INFO.phone}
                  </a>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div>
                  <p className="contact-label">Business Hours</p>
                  <p className="contact-value">{BUSINESS_HOURS.weekdays}</p>
                  <p className="contact-value-small">{BUSINESS_HOURS.saturday}</p>
                </div>
              </div>
            </div>
            <div className="footer-cta">
              <Button to={ROUTES.CONTACT} variant="secondary" size="small">
                Request a Quote
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; {new Date().getFullYear()} EventsCore Solutions. All rights reserved.</p>
          <div className="footer-legal">
            <Link to={ROUTES.ABOUT}>Privacy Policy</Link>
            <span className="separator">•</span>
            <Link to={ROUTES.ABOUT}>Terms of Service</Link>
            <span className="separator">•</span>
            <span className="footer-credit">Made by Aiden Williams</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

